var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-4 px-4 py-3 border rounded",class:_vm.alertClasses},[_c('fa-icon',{attrs:{"icon":_vm.icon,"fixed-width":""}}),_vm._v(" "+_vm._s(_vm.message)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }